<template>
  <div>
    <!-- Long -->
    <p v-if="displayType === 'long'">
      Fixed Income Type is based on the Bloomberg Market Sector classification for debt securities.
      The Fixed Income Type breakdown chart applies to directly held securities as well as securities held through funds.
      <template v-if="portfolio && benchmark">
        This breakdown applies to {{ percentCoverage.portfolio }} of {{ portfolioName }} and {{ percentCoverage.benchmark }} of {{ benchmarkName }}.
      </template>
      <template v-else-if="portfolio">
        This breakdown applies to {{ percentCoverage.portfolio }} of {{ portfolioName }}.
      </template>
      <template v-else-if="benchmark">
        This breakdown applies to {{ percentCoverage.benchmark }} of {{ benchmarkName }}.
      </template>
      Holdings data from funds uses holdings as of the fund's most recent NPORT SEC filing.
    </p>

    <!-- Short -->
    <p v-else>
      Fixed Income Type is based on the Bloomberg Market Sector classification for debt securities.
      The Fixed Income Type breakdown chart applies to directly held securities as well as securities held through funds.
      <template v-if="portfolio && benchmark">
        This breakdown applies to {{ percentCoverage.portfolio }} of {{ portfolioName }} and {{ percentCoverage.benchmark }} of {{ benchmarkName }}.
      </template>
      <template v-else-if="portfolio">
        This breakdown applies to {{ percentCoverage.portfolio }} of {{ portfolioName }}.
      </template>
      <template v-else-if="benchmark">
        This breakdown applies to {{ percentCoverage.benchmark }} of {{ benchmarkName }}.
      </template>
    </p>
  </div>
</template>


<script>
export default {
  name: 'FixedIncomeTypeMethodology',
  props: ['displayType', 'portfolio', 'benchmark'],
  computed: {
    portfolioName() {
      return this.portfolio?.name || 'Portfolio';
    },
    benchmarkName() {
      return this.benchmark?.name || 'Benchmark';
    },
    breakdown() {
      return {
        portfolio: this.portfolio?.sector_market_cap_asset_class_breakdown,
        benchmark: this.benchmark?.sector_market_cap_asset_class_breakdown,
      };
    },
    coverage() {
      return {
        portfolio: this.breakdown.portfolio?.fi_type_breakdown_coverage || 0,
        benchmark: this.breakdown.benchmark?.fi_type_breakdown_coverage || 0,
      };
    },
    percentCoverage() {
      return {
        portfolio: this.formatNumber(this.coverage.portfolio),
        benchmark: this.formatNumber(this.coverage.benchmark),
      };
    },
  },
  methods: {
    formatNumber(number) {
      return number.toLocaleString('en-US', { style: 'percent' });
    },
  },
};
</script>
